import type IProduct from "@api/models/IProduct";
import Emoji from "@core-components/emoji/Emoji";
import Icon from "@core-components/icon/Icon";
import InfoArea from "@core-components/info-area/InfoArea";
import InfoCardGrid from "@core-components/info-card/InfoCardGrid";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Text } from "@mantine/core";

interface ProductDetailsInfoProps {
  product?: IProduct;
}

export const ProductDetailsInfo = ({ product }: ProductDetailsInfoProps) => {
  const { t } = useAppTranslation("components.productDetails");
  const productT = useAppTranslation();
  const { currentRegion } = useAppRegion();

  return (
    <>
      <InfoArea
        hasShadow
        className="md:!p-10 max-lg:!w-full max-md:!max-w-none"
        description={
          <Text
            dangerouslySetInnerHTML={{
              __html:
                (product &&
                  productT.t(`${product.i18nKey}.description.text`, {
                    region: currentRegion.toUpperCase(),
                  })) ??
                "",
            }}
          />
        }
        fullWidth={false}
        headLine={
          <SSHeadline
            props={{
              stack: { align: "center" },
              title: { ta: "center", ff: "unset" },
            }}
          >
            <SSWhiteText>
              <Emoji.Pin />{" "}
              {product &&
                productT.t(`${product.i18nKey}.description.title`, {
                  region: currentRegion.toUpperCase(),
                })}
            </SSWhiteText>
          </SSHeadline>
        }
      />
      <InfoCardGrid
        cards={[
          {
            withBackground: false,
            icon: <Icon.Tick size={50} />,
            title: t("cards.rankedReady.title"),
            text: t("cards.rankedReady.text"),
          },
          {
            withBackground: false,
            icon: <Icon.TrophyStarred size={50} />,
            title: t("cards.unranked.title"),
            text: t("cards.unranked.text"),
          },
          {
            withBackground: false,
            icon: <Icon.OpenLockNoLock size={50} />,
            title: t("cards.fullAccess.title"),
            text: t("cards.fullAccess.text"),
          },
        ]}
      />
    </>
  );
};
